export default "__VITE_ASSET__f5e90250__"